import { render } from "./donutChart.vue?vue&type=template&id=5ec0d50d"
import script from "./donutChart.vue?vue&type=script&lang=js"
export * from "./donutChart.vue?vue&type=script&lang=js"

import "./donutChart.vue?vue&type=style&index=0&id=5ec0d50d&lang=css"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/statistics/donutChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ec0d50d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ec0d50d', __exports__)) {
    console.log('reload')
    api.reload('5ec0d50d', __exports__)
  }
  
  module.hot.accept("./donutChart.vue?vue&type=template&id=5ec0d50d", () => {
    console.log('re-render')
    api.rerender('5ec0d50d', render)
  })

}


export default __exports__